import { useEffect, useState } from 'react'
import { api, auth } from '../lib/api.js'
import { ReplyModal } from '../pages/Settings.jsx'
import { confirmBox, alertBox } from './Dialog.jsx'

// 左下「设置」菜单里的「我的话术」：员工自己增删改个人快捷话术（2026-10-05 Gavin 要）。
// 原来只能在工作台聊天框的快捷话术面板里改，不好找。跟那边是同一份数据，
// 改完广播 quick-replies-changed，工作台面板跟着刷新
export default function MyReplies({ onClose }) {
  const me = auth.agent
  const [list, setList] = useState([])
  const [editing, setEditing] = useState(null)
  const load = () => api.listQuickReplies()
    .then(all => setList(all.filter(r => r.agent_id === me?.id)))
    .catch(e => alertBox(e.message))
  useEffect(() => { load() }, [])

  const changed = () => { load(); window.dispatchEvent(new Event('quick-replies-changed')) }

  async function del(r) {
    if (!(await confirmBox('确认删除这条话术？'))) return
    try { await api.deleteQuickReply(r.id); changed() } catch (e) { alertBox(e.message) }
  }

  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ width: 640, maxWidth: '94vw' }}>
        <div className="spread" style={{ marginBottom: 6 }}>
          <h2 style={{ margin: 0 }}>我的话术</h2>
          <button className="btn btn-primary btn-sm" onClick={() => setEditing({})}>+ 新增话术</button>
        </div>
        <div className="small muted" style={{ marginBottom: 12 }}>
          只有你自己能看到和使用，在工作台聊天框「快捷话术 → 我的话术」里一键插入
        </div>
        {list.length === 0 ? <div className="empty">还没有自己的话术，点右上角新增</div> : (
          <div style={{ maxHeight: '55vh', overflow: 'auto' }}>
            <table>
              <thead><tr><th>快捷码</th><th>分类</th><th>内容</th><th style={{ textAlign: 'right' }}>操作</th></tr></thead>
              <tbody>
                {list.map(r => (
                  <tr key={r.id}>
                    <td className="mono">{r.shortcut || '—'}</td>
                    <td>{r.category || '—'}</td>
                    <td className="small" style={{ maxWidth: 300 }}>{r.content}</td>
                    <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                      <button className="btn-link" onClick={() => setEditing(r)}>编辑</button>
                      <button className="btn-link" style={{ color: 'var(--danger)' }} onClick={() => del(r)}>删除</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="row" style={{ justifyContent: 'flex-end', marginTop: 12 }}>
          <button className="btn" onClick={onClose}>关闭</button>
        </div>
      </div>
      {editing && <ReplyModal reply={editing} ownerId={me?.id}
        onClose={() => setEditing(null)} onSaved={() => { setEditing(null); changed() }} />}
    </div>
  )
}
